import Axios from '../../axios'

export async  function getProfile() {
    return Axios.get('/profile')
}

export async  function editProfile(data) {
    return Axios.put('/edit-profile', data)
}